import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d61b5ee8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61b5ee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d61b5ee8')) {
      api.createRecord('d61b5ee8', component.options)
    } else {
      api.reload('d61b5ee8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d61b5ee8&scoped=true", function () {
      api.rerender('d61b5ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/index.vue"
export default component.exports